// @noflow
import React from 'react'

import { Button } from '@/components/elements/atoms/Button'
import Card from '@/components/elements/atoms/Card/Card'
import Label from '@/components/elements/atoms/Label/Label'
import Text from '@/components/elements/atoms/Text/Text'
import BoxBreakdownV2 from '@/components/elements/molecules/BoxBreakdownV2/BoxBreakdownV2'
import STYLES from '@/components/pages/PriceSensitivePausedPage/PriceSensitivePausedPage.module.sass'

type Props = {
  cadence: number
  pouchSize: number
  pouchesPerDay: number
  planPricePerWeek: string
  onClick: () => void
  disabled: boolean
  discountTotalPercentage: number
}

const ResumePlanCard = ({
  cadence,
  pouchSize,
  pouchesPerDay,
  planPricePerWeek,
  onClick,
  disabled,
  discountTotalPercentage
}: Props): JSX.Element => {
  const namespace = 'account'
  return (
    <Card border="none" padding={24}>
      <div className={STYLES.cardContent}>
        <Text
          namespace={namespace}
          text={`price_sensitive_paused_page.options.resume_card.title`}
          variant="display20"
          margin={false}
        />
        <div className={STYLES.boxBreakdown}>
          <BoxBreakdownV2
            cadence={cadence}
            pouchSize={pouchSize}
            pouchesPerDay={pouchesPerDay}
          />
        </div>
        <div className={STYLES.priceRow}>
          <Text
            namespace={namespace}
            text={`price_sensitive_paused_page.options.resume_card.price`}
            variant="display16"
            margin={false}
            variables={{
              planPricePerWeek: planPricePerWeek
            }}
          />
          {discountTotalPercentage > 0 && (
            // eslint-disable-next-line jsx-a11y/label-has-for
            <Label
              text={{
                text: 'price_sensitive_paused_page.options.resume_card.discount',
                namespace,
                variables: { discount: `${discountTotalPercentage}%` }
              }}
              variant="greenDiscount"
              size="regular"
            />
          )}
        </div>
        <Button
          onClick={onClick}
          typography={{
            namespace,
            text: `price_sensitive_paused_page.options.resume_card.cta`
          }}
          fullWidth
          identifier="price_sensitive_paused_page.resume_card.resume_cta"
          disabled={disabled}
        />
      </div>
    </Card>
  )
}

export default ResumePlanCard
